import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { Image } from 'semantic-ui-react';

import type { StepsConfig } from '@features/app-tour/app-tour.models';

import s from './tour-steps.scss';

const stepStyles = {
  options: {
    width: '65rem',
  },
};

const robotEl = <Image src="/img/sbom_bomb.svg" className={s.sbomImg} />;

const Step1 = () => {
  useStyles(s);
  return (
    <div className={classNames(s.root, s.alignLeft)}>
      {robotEl}
      <p>
        The <strong>Imported SBOMs</strong> view is used to collect one or more
        imported SBOMs together into a group. Groups can be used to represent an
        application, project, or organizational structure, like a division,
        business, unit, or product team.
      </p>
    </div>
  );
};

const Step2 = () => {
  useStyles(s);
  return (
    <div className={classNames(s.root, s.alignLeft)}>
      {robotEl}
      <p>
        Information about the imported SBOM document can be viewed in the&nbsp;
        <strong>Summary</strong> tab. Packages within an imported SBOM can be
        viewed via the SBOM&nbsp;
        <strong>Contents</strong> tab. Vulnerabilities within imported SBOMs can
        be viewed for a group of SBOMs or an individual SBOM via the&nbsp;
        <strong>Vulnerabilities</strong> tab.
      </p>
    </div>
  );
};

const Step3 = () => {
  useStyles(s);
  return (
    <div className={classNames(s.root, s.alignLeft)}>
      {robotEl}
      <p>
        Vulnerabilities can be filtered by age, severity, or CVSS score. The
        Anchore Rank is Anchore&#39;s recommended vulnerability sorting based on
        a computed composite score derived from the CNA Highest CVSS score, EPSS
        percentile, and KEV status. It can be used to prioritize vulnerabilities
        to address first as part of a review and remediation process.
      </p>
    </div>
  );
};

export default (): StepsConfig => ({
  id: 'sbom',
  data: {
    overrideTourPropsOnClose: {
      '/sboms': {
        isDisabled: true,
        showIntro: true,
      },
      '/sboms/groups/:groupId/:tab?': {
        isDisabled: true,
        showIntro: true,
      },
      '/sboms/:sbomId/:revisionId?/:tab?': {
        isDisabled: true,
        showIntro: true,
      },
    },
  },
  steps: [
    {
      styles: stepStyles,
      content: <Step1 />,
      placement: 'center',
      target: 'body',
    },
    {
      styles: stepStyles,
      content: <Step2 />,
      placement: 'center',
      target: 'body',
    },
    {
      styles: stepStyles,
      content: <Step3 />,
      placement: 'center',
      target: 'body',
    },
  ],
});
